/*
 * Author: harper
 * File Created: Thursday, 24-05-16 07:10 pm
 * Last Modified: Monday, 25-04-28 05:34 pm, by Dw
 */

import { Logger } from '@web/utils';

const logger = new Logger({ module: 'WEB' });

export default logger;
